import { render, staticRenderFns } from "./list-study-tasks.vue?vue&type=template&id=2307924d&scoped=true&"
import script from "./list-study-tasks.vue?vue&type=script&lang=ts&"
export * from "./list-study-tasks.vue?vue&type=script&lang=ts&"
import style0 from "./list-study-tasks.vue?vue&type=style&index=0&id=2307924d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2307924d",
  null
  
)

export default component.exports